/**
 * @desc 商城查询网站公告分页列表
 */
import {
  PageNoticeEntity,
  NoticePageQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNoticePageParameter = NoticePageQuery

const method = 'GET'
const url = '/content/mall/notice/page'

export const queryNoticePageApi = (
  params?: QueryNoticePageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageNoticeEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryNoticePageApi.method = method
queryNoticePageApi.url = url
